import { Navigate, Route, Routes } from "react-router-dom";
import { isConfigured } from "./lib/env";
import { ConfigGate } from "./components/ConfigGate";
import { AttendancePage } from "./mobile/AttendancePage";
import { AdminAttendancePage } from "./admin/AdminAttendancePage";
import { AttendanceSettingsPage } from "./admin/AttendanceSettingsPage";
import { AttendancePrivacyPage, attendancePrivacyPath } from "./legal/AttendancePrivacyPage";

export function App() {
  return <Routes>
    <Route path={attendancePrivacyPath} element={<AttendancePrivacyPage />} />
    {isConfigured ? <>
      <Route path="/attendance" element={<AttendancePage />} />
      <Route path="/admin/attendance" element={<AdminAttendancePage />} />
      <Route path="/admin/attendance/settings" element={<AttendanceSettingsPage />} />
      <Route path="*" element={<Navigate to="/attendance" replace />} />
    </> : <Route path="*" element={<ConfigGate />} />}
  </Routes>;
}
